// packages/web/src/components/auth/PlatformAdminRoute.tsx
// ═══════════════════════════════════════════════════════════════════
// Route guard: only renders children if user is a platform admin.
// Non-platform-admin users see a 404-style page (not "Access Denied",
// to avoid revealing the existence of admin routes).
// ═══════════════════════════════════════════════════════════════════

import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export function PlatformAdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 32, height: 32, border: '3px solid rgba(99,102,241,0.2)', borderTopColor: '#6366f1', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
      </div>
    );
  }

  // Strict check: must be explicitly flagged as platform admin
  if (!user?.is_platform_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
